module.exports = __webpack_public_path__ + "static/media/logo-transparent.a31d8111.png";